// data para gráfica Top Productos (TopProductos.js)
export const PRODUCT_DEFAULT = {
    labels: ['Sin ventas'],
    datasets: [
        {
            label: 'Unidades vendidas',
            data: [1],
            backgroundColor: [
                '#CD6155',
                '#AF7AC5',
                '#5499C7',
                '#48C9B0',
                '#F4D03F',
                '#DC7633',
                '#5F6A6A',
                '#196F3D',
                '#212F3C',
                '#154360'
            ],
            borderColor: [
                '#CD6155',
                '#AF7AC5',
                '#5499C7',
                '#48C9B0',
                '#F4D03F',
                '#DC7633',
                '#5F6A6A',
                '#196F3D',
                '#212F3C',
                '#154360'
            ]
        }
    ]
};
export const TOP_PRODUCTS_DATA = {
    todayData: PRODUCT_DEFAULT,
    weekData: PRODUCT_DEFAULT,
    fortnightData: PRODUCT_DEFAULT,
    monthData: PRODUCT_DEFAULT,
    quarterData: PRODUCT_DEFAULT,
    yearToDateData: PRODUCT_DEFAULT,
    annualData: PRODUCT_DEFAULT,
    filteredData: PRODUCT_DEFAULT
};

export const DATE_RANGES = [{
    key: 'todayData',
    rangeKey: 'today',
    label: 'Día'
}, {
    key: 'weekData',
    rangeKey: 'week',
    label: 'Semanal'
}, {
    key: 'fortnightData',
    rangeKey: 'fortnight',
    label: 'Quincenal'
}, {
    key: 'monthData',
    rangeKey: 'month',
    label: 'Mensual'
}, {
    key: 'quarterData',
    rangeKey: 'quarter',
    label: 'Trimestral'
}, {
    key: 'yearToDateData',
    rangeKey: 'yearToDate',
    label: 'Year to Date'
}, {
    key: 'annualData',
    rangeKey: 'annual',
    label: 'Anual'
}, {
    key: 'filteredData',
    rangeKey: 'filtered',
    label: 'Rango de fechas'
}];

export const FIRST_SEMESTER_MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio'];
export const SECOND_SEMESTER_MONTHS = ['Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

export const NEW_CLIENTS_DATASET = [
    {
        label: 'Clientes nuevos',
        data: [0, 0, 0, 0, 0, 0],
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
    },
];

// tabla top 10 clientes frecuentes
export const REGULAR_CUSTOMERS_COLUMNS = [
    {
        field: 'id',
        headerName: 'Top'
    },
    {
        field: 'name',
        headerName: 'Nombre',
        minWidth: 100,
        flex: 1,
        editable: true
    },
    {
        field: 'lastname',
        headerName: 'Apellido',
        minWidth: 100,
        flex: 1,
        editable: true
    },
    {
        field: 'email',
        minWidth: 100,
        headerName: 'Correo electrónico',
        flex: 1,
        editable: true
    },
    {
        field: 'purchases',
        headerName: 'Compras',
        minWidth: 100,
        flex: 1,
        editable: true
    }
];
